import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConstantesConfiguracionCalendarioEnum } from '@appNeo/core/helpers/enums/constantesConfiguracionCalendarioEnum';
import { TiposEventosEnum } from '@appNeo/core/helpers/enums/tiposEventosEnum';
import { IMetodoPago } from '@appNeo/core/interfaces/IMetodoPago';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { IReserva } from '@appNeo/core/interfaces/IReserva';
import { ITipoEvento } from '@appNeo/core/interfaces/ITipoEvento';
import { CalendarioOcioService, IFiltrosConsultaDisponibilidad, ITurno } from '@appNeo/core/services/calendario-ocio/calendario-ocio.service';
import { PaquetesService } from '@appNeo/core/services/paquetes/paquetes.service';
import { ReservaService } from '@appNeo/core/services/reserva/reserva.service';
import { RESPUESTA_API_ERROR_ENVIO_EMAIL_417 } from '@appNeo/neoCore/interceptors/httpError/http-error.interceptor';
import { AuthService } from '@appNeo/neoCore/services/auth/auth.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { SpinnerService } from '@appNeo/neoCore/services/spinner/spinner.service';
import { CalendarioComponent, IConfiguracionCalendario } from '@appNeo/neoShared/components/calendario/calendario/calendario.component';
import { FormularioComponent } from '@appNeo/neoShared/components/formulario/formulario.component';
import { NotificacionComponent } from '@appNeo/neoShared/components/notificacion/notificacion.component';
import { StepperComponent } from '@appNeo/neoShared/components/stepper/stepper.component';
import { AccionDialogEnum } from '@appNeo/neoShared/helpers/enums/AccionDialog.enum';
import { IconEnum } from '@appNeo/neoShared/helpers/enums/Icon.enum';
import { NotificacionEnum } from '@appNeo/neoShared/helpers/enums/Notificacion.enum';
import { ClasesFormularioAnchoEnum, IFormInput } from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import { INPUTSCREACIONENTIDAD1, INPUTSCREACIONENTIDAD2 } from '@appNeo/neoShared/pages/layoutTikects/tickets-configuracion';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { CalendarEventNeo } from '@appNeo/neoShared/services/calendario/calendario.service';
import { FormularioService } from '@appNeo/neoShared/services/formulario/formulario.service';
import { UtilidadesLayoutService } from '@appNeo/neoShared/services/utilidades/utilidades-layout.service';
import { MAXIMO_NINOS } from '@appNeo/pages/area-cliente/area-cliente/pages/mis-invitados/mis-invitados-data';
import { environment } from '@environments/environment';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { addDays, format, getMonth, subDays } from 'date-fns';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { CONFIGURACION_CALENDARIO_RESERVAR, FORMINPUT_CODIGO_DESCUENTO, FORMINPUT_RESERVAR_DATOSCONTACTO, FORMINPUT_RESERVAR_DATOSFIESTA, FORMINPUT_RESERVAR_FIADELCUMPLE } from '../../reservar-data';
import { MatDialog } from '@angular/material/dialog';
import { AccionesDialogComponent } from '@appNeo/neoShared/components/acciones-dialog/acciones-dialog.component';
import { CodigosDescuentoService } from '@appNeo/core/services/codigos-descuento/codigos-descuento.service';


@Component({
  selector: 'neo-formulario-wizard-cumpleanos',
  templateUrl: './formulario-wizard-cumpleanos.component.html',
  styleUrls: ['./formulario-wizard-cumpleanos.component.scss'],
  providers: [FormularioService]
})
export class FormularioWizardCumpleanosComponent implements OnInit, AfterViewInit {

  // congiguracion layout formulario
  clasesFormularioAnchoEnum = ClasesFormularioAnchoEnum.formularioAnchoCompleto;
  aplicarFlex: boolean = true;

  entidad: IReserva;

  // controlados paso step
  stepControlBusqueda: boolean = true;
  stepControlDiaDelCumple: FormGroup;
  stepControlDatosFiesta: FormGroup;
  stepControlDatosContacto: boolean;
  stepControlPago: boolean = false;
  stepControlConfirmacion: boolean = true;
  indexStepActual: number = 1;
  turnosDisponibles = [];
  permitirProcesoPago: boolean = false;

  // PASO 2: Conf cumpleano
  @ViewChild('notificacionCalendario') notificacionCalendario: NotificacionComponent;
  @ViewChild('calendario') calendario: CalendarioComponent;
  configuracionCalendario: IConfiguracionCalendario = CONFIGURACION_CALENDARIO_RESERVAR;



  // PASO2: Datos de la fiesta
  @ViewChild('notificacionDiaDelCumple') notificacionDiaDelCumple: NotificacionComponent;
  @ViewChild('formStepControlDiaDelCumple') formStepControlDiaDelCumple: FormularioComponent;
  formInputPaso2 = FORMINPUT_RESERVAR_FIADELCUMPLE;

  // PASO3: Datos de la fiesta
  @ViewChild('notificacionDatosFiesta') notificacionDatosFiesta: NotificacionComponent;
  @ViewChild('formStepControlDatosFiesta') formStepControlDatosFiesta: FormularioComponent;
  formInputPaso3 = FORMINPUT_RESERVAR_DATOSFIESTA;

  // PASO4: Datos de contacto
  @ViewChild('notificacionDatosContacto') notificacionDatosContacto: NotificacionComponent;
  @ViewChild('formStepControlDatosContacto') formStepControlDatosContacto: FormularioComponent;
  formInputPaso4 = FORMINPUT_RESERVAR_DATOSCONTACTO

  @ViewChild('dialogoCodigoDescuento') dialogoCodigoDescuento: TemplateRef<any>;
  @ViewChild('formularioCodigoDescuento') formularioCodigoDescuento: FormularioComponent;
  @ViewChild('accionDialogCodigoDescuento') accionDialogCodigoDescuento: AccionesDialogComponent;
  @ViewChild('notificacionCodigoDescuento') notificacionCodigoDescuento: NotificacionComponent;
  formInputCodigoDescuento = FORMINPUT_CODIGO_DESCUENTO;
  codigoDecuentoValido = null;

  @ViewChild('stepper') stepper: StepperComponent;

  @Output() modificarBusqueda = new EventEmitter<boolean>();

  tiposEvento: ITipoEvento[] = [];
  paquetes: IPaquete[] = [];
  metodosPago: IMetodoPago[] = [];
  // extrasPaquetes: IPaquete[] = [];
  importeFianza: number;
  tiposEventosEnum = TiposEventosEnum;
  reservasDisponibles: CalendarEventNeo[] = [];



  @ViewChild(StripeCardComponent) card: StripeCardComponent;

  elementsOptions: StripeElementsOptions = {
    locale: 'es'
  };

  cardForm: FormGroup;
  procesandoPago: boolean = false;
  errorEnvioEmailAccesoPagoOK: boolean = false;


  constructor(
    public dialog: MatDialog,
    private formulario: FormularioService,
    public calendarioOcioService: CalendarioOcioService,
    private utilidadesLayout: UtilidadesLayoutService,
    public reservaService: ReservaService,
    public descuentosService: CodigosDescuentoService,
    public auxiliarService: AuxiliarService,
    private route: ActivatedRoute,
    private element: ElementRef,
    protected stripeService: StripeService,
    private spinnerService: SpinnerService,
    private authSerive: AuthService,
    private ocioCalendario: CalendarioOcioService,
    private preferenciasService: PreferenciasService,
    private paquetesService: PaquetesService
  ) {
    this.spinnerService.showSpinner();
    this.route.data.subscribe(
      response => {
        this.tiposEvento = (response?.tiposEvento) ? response.tiposEvento : [];
        this.paquetes = (response?.paquetes?.listadoEntidad)
          ? response?.paquetes?.listadoEntidad.filter(item => item.activo)
          : [];
        this.metodosPago = (response?.reserva?.metodosPago) ? response?.reserva?.metodosPago : [];
        this.importeFianza = (response?.reserva?.importeFianza) ?? 0;
      }
    );
  }

  ngOnInit(): void {
    this.onNavegacionCalendario(new Date());
    this.cargarDatos();
  }

  ngOnDestroy(): void {
    // OJO, esto produce que cada vez que vamos para atras, de destruya componente, y se inicia busqueda
    // if (this.reservaService.esPagoCorrecto()) {
    this.desencadenarAccionDestruirComponente();
    // this.reservaService.eliminarReservaStorage();
    // }
  }

  desencadenarAccionDestruirComponente() {
    console.log('step desencadenarAccionDestruirComponente');
    this.ocioCalendario.eliminarFiltros();
    this.paquetesService.entidad = undefined;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.stepControlDiaDelCumple = this.formStepControlDiaDelCumple.formValidators;
      this.stepControlDatosFiesta = this.formStepControlDatosFiesta.formValidators;
      this.stepControlDatosContacto = this.formStepControlDatosContacto.formValidators.valid && this.permitirProcesoPago;
    });
  }

  onClickAccion(accion) {
    switch(accion) {
      case 'descuento':
        this.dialog.open(this.dialogoCodigoDescuento, {disableClose: true});
      break;
      case 'eliminar':
        this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, true, ['añadirCodigoDescuento'], ['añadirCodigoDescuento']);
        this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, false, ['eliminarCodigoDescuento'], ['eliminarCodigoDescuento']);
        this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, false, ['codigoDescuentoValido'], ['codigoDescuentoValido']);
        this.formStepControlDatosContacto.formValidators.get('codigoDescuentoValido').setValue(null);
      break;
    }
  }

  cargarDatos(indexStepActual?) {
    let numeroNinosEstimadoMaximo = MAXIMO_NINOS;
    let idExtras: any = (this.calendarioOcioService.filtrosConsultaDisponibilidad$.value?.idExtras) ? (this.calendarioOcioService.filtrosConsultaDisponibilidad$.value?.idExtras) : undefined;


    console.log('Consulta disponibilidad de los extras ', idExtras);

    // let numeroNinosEstimadoMaximo = Number(this.preferenciasService.get(ConstantesConfiguracionCalendarioEnum.MaximoNinosAsistentes)) + 1;
    let idPaquete = (this.reservaService.entidad$.value && this.reservaService.entidad$.value.idPaquete) ? this.reservaService.entidad$.value.idPaquete : this.calendarioOcioService.filtrosConsultaDisponibilidad$.value.idPaquete;
    let idTipoTurno = (this.reservaService.entidad$.value && this.reservaService.entidad$.value.idTipoTurno) ? this.reservaService.entidad$.value.idTipoTurno.toString() : undefined;
    // datos paso 3
    this.auxiliarService.busquedaPropiedad(this.formInputPaso3, 'formControlName', 'idPaquete').datos = this.paquetes;
    this.auxiliarService.busquedaPropiedad(this.formInputPaso3, 'formControlName', 'idPaquete').valor = idPaquete;

    // datos paso 4
    this.auxiliarService.busquedaPropiedad(this.formInputPaso4, 'formControlName', 'idMetodoPago').datos = this.metodosPago;
    this.auxiliarService.busquedaPropiedad(this.formInputPaso4, 'formControlName', 'importeFianza').valor = this.importeFianza;

    switch (indexStepActual) {
      case 2:
        let filtrosConsultaDisponibilidadDia = { idPaquete: this.reservaService.entidad$.value.idPaquete, fecha: this.reservaService.entidad$.value.fechaEvento, idExtras };
        this.calendarioOcioService.consultaDisponibilidadDia(filtrosConsultaDisponibilidadDia).subscribe(
          datos => {
            if (datos?.configuracionDias && datos.configuracionDias.length) {
              let turnosDisponibles = datos.configuracionDias[0].turnos;
              let datosTurnos = [];
              Object.values(turnosDisponibles).forEach((valor, key, array) => {
                datosTurnos.push({ id: valor['idTipoTurno'], nombre: valor['nombreTipoTurno'], meta: array[key] });
              });
              let turnoSeleccionado = datosTurnos.find(turno => turno.id == idTipoTurno);
              this.auxiliarService.busquedaPropiedad(this.formInputPaso3, 'formControlName', 'numeroNinosEstimado').datos = this.auxiliarService.obtenerSeleccionNumero(1, (turnoSeleccionado?.meta?.cantidadRestanteInvitadosDisponible + 1));
            } else {
              this.notificacionCalendario.crearNotificacion(NotificacionEnum.Error, 'Error!', `El turno seleccionado para la fecha ${filtrosConsultaDisponibilidadDia.fecha} ya no está disponible.`, true, IconEnum.Error);
              this.onAtras();
            }
          },
          e => {
            this.notificacionCalendario.crearNotificacion(NotificacionEnum.Error, 'Error!', `El turno seleccionado para la fecha ${filtrosConsultaDisponibilidadDia.fecha} ya no está disponible.`, true, IconEnum.Error);
            this.onAtras();
          });
        break;
    }

    setTimeout(() => {
      if (this.metodosPago.length == 1) {
        if (this.formStepControlDatosContacto) {
          this.formStepControlDatosContacto.formValidators.get('idMetodoPago').setValue(this.metodosPago[0].id);
        }
      }
    })
  }

  anterior() {
    this.stepper.previous();
  }

  siguiente() {
    this.stepper.next();
  }

  onNavegacionCalendario(data) {
    // fechas del mes sin margenes
    let filtrosMes = this.obtenerParametrosConsultaConfiguracion(data?.diaVista, 0, 0);
    let { visible, ultimoMes = false } = this.determinarMesDisponible(filtrosMes.fechaHasta);
    console.log('RESULTADO { visible, ultimoMes }', filtrosMes.fechaHasta, visible, ultimoMes);
    if (visible) {
      let margenDiasPosterior = (!ultimoMes) ? 6 : 0;
      this.consultaDisponibilidad(this.obtenerParametrosConsultaConfiguracion(data?.diaVista, 6, margenDiasPosterior));
    } else {
      this.reservasDisponibles = [];
    }
    // this.consultaDisponibilidad(this.obtenerParametrosConsultaConfiguracion(data?.diaVista));
  }

  // si mes visible y si es ultmo mes visible
  determinarMesDisponible(fecha) {
    if (fecha) {
      // TODO: Añadir valor matrix_numeroMesesVisibilidadCalendarioPublico
      let meses = Number(this.preferenciasService.get('matrix_numeroMesesVisibilidadCalendarioPublico'));
      if (meses > 0) {
        const fechaMaximaMesVisible = this.auxiliarService.ultimoDiaMes(<Date>this.auxiliarService.fechaDentroDeMeses(meses));
        let visible = this.auxiliarService.fechaEntre(this.auxiliarService.convertirDateEs(fecha), new Date(), fechaMaximaMesVisible);

        let ultimoMesVisible = getMonth(fechaMaximaMesVisible);
        let mesActual = getMonth(this.auxiliarService.convertirDateEs(fecha));
        return { visible, ultimoMes: (ultimoMesVisible == mesActual) };
      } else {
        return { visible: true, ultimoMes: false };
      }
    }
    return { visible: false, ultimoMes: undefined };
  }

  onIniciarConfiguracion() {
    this.stepper.selectedIndex = 1;
    this.cargarDatos(this.indexStepActual);
    this.formStepControlDiaDelCumple.reset();
  }

  onContinuar() {
    this.submitFormulario(this.indexStepActual);
    this.siguiente();
    this.cargarDatos(this.indexStepActual);
  }

  onReservar() {
    this.submitFormulario(this.indexStepActual);
    this.siguiente();
    this.cargarDatos(this.indexStepActual);
  }

  onPagar() {
    this.procesandoPago = true;
    this.createToken();
  }


  onAtras() {
    this.anterior();
  }

  submitFormulario(step: number) {
    console.log('SUBMIT FORMULARIO .... ');
    if (this.notificacionCalendario) {
      this.notificacionCalendario.eliminarNotificaciones();
    }
    if (this.notificacionDatosContacto) {
      this.notificacionDatosContacto.eliminarNotificaciones();
    }
    if (this.notificacionDatosFiesta) {
      this.notificacionDatosFiesta.eliminarNotificaciones();
    }
    switch (step) {
      case 1:
        // validar fecha idTipoTurno
        this.formStepControlDiaDelCumple.formValueReset = true;
        let objetoStep0 = this.formStepControlDiaDelCumple.validaCampos(false);
        if ((objetoStep0 && objetoStep0.formulario.invalid)) {
          this.formStepControlDiaDelCumple.formValueReset = true;
          this.notificacionCalendario.eliminarNotificaciones();
          this.notificacionCalendario.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Selecione los campos obligatorios', true, IconEnum.Error);
          this.focusError();
        } else {
          this.actualizarReservaStore(objetoStep0.valores);
          if (!this.existeFechaTurnoSeleccionada()) {
            this.notificacionCalendario.eliminarNotificaciones();
            this.notificacionCalendario.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Seleccionar dia y turno deseado', true, IconEnum.Error);
            return;
          }
        }
        break;
      case 2:
        this.formStepControlDatosFiesta.formValueReset = true;
        let objetoStep1 = this.formStepControlDatosFiesta.validaCampos(false);
        if ((objetoStep1 && objetoStep1.formulario.invalid)) {
          this.formStepControlDatosFiesta.formValueReset = true;
          this.notificacionDatosFiesta.eliminarNotificaciones();
          this.notificacionDatosFiesta.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Rellene los campos obligatorios', true, IconEnum.Error);
          this.focusError();
          return;
        } else {
          this.actualizarReservaStore(objetoStep1.valores);
        }
        break;
      case 3:
        this.formStepControlDatosContacto.formValueReset = true;
        let objetoStep2 = this.formStepControlDatosContacto.validaCampos(false);
        if ((objetoStep2 && objetoStep2.formulario.invalid)) {
          this.formStepControlDatosContacto.formValueReset = true;
          this.notificacionDatosContacto.eliminarNotificaciones();
          this.notificacionDatosContacto.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Rellene los campos obligatorios', true, IconEnum.Error);
          this.focusError();
          return;
        } else {

          this.grabarReserva(objetoStep2.valores);

        }
        break;
    }
  }

  createToken() {
    if (environment.debug) {
      console.log('[RESERVAR][PAGO STRIPE] ::createtoken ')
    }
    //const name = this.cardForm.get('name').value;
    this.stripeService
      .createToken(this.card.element)
      .subscribe(async result => {
        if (result.token) {
          // Use the token
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::createtoken ', 'obtenermos token');
          }
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::pagarReservaStripe ', 'Inicio proceso para ', this.reservaService.entidad$.value.codigo);
          }

          this.reservaService.pagarReservaStripe(this.reservaService.entidad$.value.codigo, result.token.id).subscribe(async res => {
            if (environment.debug) {
              console.log('[RESERVAR][PAGO STRIPE] ::pagarReservaStripe ', 'Respuesta ', res);
            }
            this.establecerEstadoReservadoPagoOk(res, false);

          }, async error => {
            if (environment.debug) {
              console.log('[RESERVAR][PAGO STRIPE] ::pagarReservaStripe ', 'ERROR libreria o envio email 417', error);
            }

            if (error?.codigoError == RESPUESTA_API_ERROR_ENVIO_EMAIL_417) {
              if (environment.debug) {
                console.log('[RESERVAR][PAGO STRIPE] ::pagarReservaStripe ', 'ERROR envio email 417 llamamaos a establecerEstadoReservadoPagoOk', error);
              }
              this.establecerEstadoReservadoPagoOk({ codigo: this.reservaService.entidad$.value.codigo }, true, error);
            } else {
              this.stepControlPago = true;
              setTimeout(() => {
                this.reservaService.intentoPagoFallido = true;
                this.siguiente();
                this.procesandoPago = false;
              })
            }
            // this.actualizarProducto();
            // await loading.dismiss();
          });
          // this.pagoConStripe(result.token.id);

        } else if (result.error) {
          // await loading.dismiss();
          // Error creating the token
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::createtoken ', 'error token');
          }
          this.stepControlPago = true;
          setTimeout(() => {
            this.reservaService.intentoPagoFallido = true;
            this.siguiente();
            this.procesandoPago = false;
          })
        }
        // this.procesandoPago = false;
      });
  }
  establecerEstadoReservadoPagoOk(res, errorEmail = false, respuestaError = undefined) {
    if (res.codigo) {
      if (environment.debug) {
        console.log('[RESERVAR][PAGO STRIPE] ::establecerEstadoReservaReservado ', res?.codigo, 'error email 417 ', errorEmail);
      }
      this.reservaService.establecerEstadoReservaReservado(res.codigo).subscribe(
        x => {
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::establecerEstadoReservaReservado ', res.codigo, 'TODO OK');
          }

          this.reservaService.eliminarReservaStorage();
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::eliminarReservaStorage', res.codigo, 'TODO OK');
          }
          this.actualizarReservaStore(x);
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::actualizarReservaStore', res.codigo, 'TODO OK');
          }
          this.stepControlPago = this.reservaService.esPagoCorrecto();
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::stepControlPago = OK');
          }
          setTimeout(() => {
            this.procesandoPago = false;
            this.errorEnvioEmailAccesoPagoOK = (errorEmail);
            if (environment.debug) {
              console.log('[RESERVAR][PAGO STRIPE] ::setTimeout procesandoPago ', this.procesandoPago, 'errorEnvioEmailAccesoPagoOK ', this.errorEnvioEmailAccesoPagoOK, ' siguiente');
            }
            this.siguiente();
          })
        },
        e => {
          if (environment.debug) {
            console.log('[RESERVAR][PAGO STRIPE] ::establecerEstadoReservaReservado ', res.codigo, 'KO');
          }
          this.procesandoPago = false;
        }
      )
    } else {

      if (environment.debug) {
        console.log('[RESERVAR][PAGO STRIPE] ::pagarReservaStripe ', 'ERROR STRIPE NO CODIGO');
      }
      this.reservaService.intentoPagoFallido = true;
      this.procesandoPago = false;
    }
  }

  onCambioPaso(evento) {
    this.indexStepActual = evento.selectedIndex;
    if (evento.selectedIndex === 0) {
      this.modificarBusqueda.emit(true);
    }

  }

  // CALENDARIO
  onClickDia(evento) {
    console.log(evento);
    if (evento.fecha && evento.eventosDia.length) {
      let fechaEvento = format(evento.fecha, environment.formatFechaApi);
      let idPaquete = this.calendarioOcioService.filtrosConsultaDisponibilidad$.value.idPaquete;
      let eventos = evento.eventosDia;
      let idExtrasOpcionales = this.calendarioOcioService.filtrosConsultaDisponibilidad$.value.idExtras;
      let turnosDia = Object.assign([], eventos[0].meta.dia.turnos);
      this.establecerFechaTurnoHora(fechaEvento, TiposEventosEnum.Cumpleanos, idPaquete, idExtrasOpcionales, turnosDia, undefined, undefined);
    }
  }
  onClickTurnoDisponible(evento) {
    // let turno = evento.meta.dia.turnos.find(item => item.nombreTipoTurno == evento.title);
    // this.reservaService.actualizarReservaStorage({
    //   idTipoEvento: TiposEventosEnum.Cumpleanos,
    //   // idTipoTurno: evento.meta.dia.turno.idTipoTurno,
    //   idTipoTurno: turno.idTipoTurno,
    //   fechaEvento: evento.meta.dia.dia,
    //   idPaquete: this.calendarioOcioService.filtrosConsultaDisponibilidad$.value.idPaquete
    // });

    // // rellenamos combo turnos
    // this.turnosDisponibles = evento.meta.dia.turnos;
    // let datosTurnos = [];
    // Object.values(this.turnosDisponibles).forEach((valor, key, array) => {
    //   datosTurnos.push({ id: valor['idTipoTurno'], nombre: valor['nombreTipoTurno'], meta: array[key] });
    // });
    // if (evento.meta.dia.dia) {
    //   this.auxiliarService.busquedaPropiedad(this.formInputPaso2, 'formControlName', 'idTipoTurno').datos = datosTurnos;
    //   this.formStepControlDiaDelCumple.formValidators?.controls['idTipoTurno'].setValue(turno.idTipoTurno);
    //   let turnoSeleccionado = datosTurnos.find(tur => tur.id == turno.idTipoTurno);
    //   this.establecerHorasDisponiblesTipoTurno(turno.idTipoTurno, { ...turnoSeleccionado, ...turnoSeleccionado.meta });
    // }
  }

  establecerFechaTurnoHora(fecha, idTipoEvento, idPaquete, idExtrasOpcionales, turnos: ITurno[], turno?: ITurno, idTipoTurno?) {
    if (fecha) {
      if (this.notificacionCalendario) {
        this.notificacionCalendario.eliminarNotificaciones();
      }
      this.formStepControlDiaDelCumple.formValidators.reset();
      this.reservaService.actualizarReservaStorage({
        idTipoEvento: idTipoEvento,
        idTipoTurno: idTipoTurno,
        fechaEvento: fecha,
        idPaquete: idPaquete,
        idExtrasOpcionales: idExtrasOpcionales
      });

      // rellenamos combo turnos
      this.turnosDisponibles = turnos;
      let datosTurnos = [];
      Object.values(this.turnosDisponibles).forEach((valor, key, array) => {
        datosTurnos.push({ id: valor['idTipoTurno'], nombre: valor['nombreTipoTurno'], meta: array[key] });
      });
      if (datosTurnos.length) {
        this.auxiliarService.busquedaPropiedad(this.formInputPaso2, 'formControlName', 'idTipoTurno').datos = datosTurnos;
        if (!turno && this.turnosDisponibles.length == 1) {
          turno = this.turnosDisponibles[0];
        }
        if (turno) {
          this.formStepControlDiaDelCumple.formValidators?.controls['idTipoTurno'].setValue(turno?.idTipoTurno);
          let turnoSeleccionado = datosTurnos.find(tur => tur.id == turno?.idTipoTurno);
          this.establecerHorasDisponiblesTipoTurno(turno.idTipoTurno, { ...turnoSeleccionado, ...turnoSeleccionado.meta });
        }
      }
    }

  }

  consultaDisponibilidad(filtros: IFiltrosConsultaDisponibilidad) {
    this.calendarioOcioService.consultaDisponibilidad(filtros).subscribe(
      x => { this.reservasDisponibles = x },
      e => {
        this.notificacionCalendario.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Se ha producido un error al intentar consultar disponibilidad ' + e.data, true, IconEnum.Error);
      });
  }
  onCambioFormulario(datosCambio, tagFormulario) {
    switch (tagFormulario) {
      case 'formInputPaso2':
        let turno = Object.values(this.turnosDisponibles).find((valor, key, array) => {
          return valor.idTipoTurno == datosCambio.event.idTipoTurno;
        });
        let primerCambio = datosCambio.campos.length == 0 && datosCambio.event.idTipoTurno != this.reservaService.entidad$.value?.idTipoTurno;
        let cambioPaquete = datosCambio.campos.includes('idTipoTurno') && datosCambio.event.idTipoTurno != this.reservaService.entidad$.value?.idTipoTurno;
        if (primerCambio || cambioPaquete) {
          this.reservaService.actualizarReservaStorage({ turno, idTipoTurno: datosCambio.event.idTipoTurno });
          this.establecerHorasDisponiblesTipoTurno(datosCambio.event.idTipoTurno, turno);
        }
        break;
      default:
        // throw new Error(`[ERROR RESERVAR] onCambioFormulario no detectado el formulario ${tagFormulario}`);
        break;

    }
  }

  focusError() {
    const elemento = this.element.nativeElement.querySelector('neo-notificacion');
    if (elemento) {
      elemento.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }
  }

  onAccionDialogoCodigoDescuento(accion) {
    if (accion.id == 'btn-confirmar') {
      this.submitFormularioCodigoDescuento();
    }
  }

  submitFormularioCodigoDescuento() {
    let objeto_fDF = (this.formInputCodigoDescuento) ? this.formularioCodigoDescuento.validaCampos(false) : undefined;

    if ((objeto_fDF && objeto_fDF.formulario.invalid)) {
      this.formularioCodigoDescuento.formValueReset = true;
      this.accionDialogCodigoDescuento.notificacionDialogo.eliminarNotificaciones();
      this.accionDialogCodigoDescuento.notificacionDialogo.crearNotificacion(NotificacionEnum.Error, 'Error', 'Rellene los campos obligatorios', true, IconEnum.Error);
      return;
    }
    let valores_fPF = (objeto_fDF && objeto_fDF.formulario.valid) ? objeto_fDF.valores : {};
    this.validarCodigoDescuento(valores_fPF);
  }

  validarCodigoDescuento(peticion) {
    let request = {'codigoDescuento': peticion.codigoDescuento}
      this.descuentosService.comprobarDescuento(request).subscribe(
        x => {
          this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, false, ['añadirCodigoDescuento'], ['añadirCodigoDescuento']);
          this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, true, ['eliminarCodigoDescuento'], ['eliminarCodigoDescuento']);
          this.formStepControlDatosContacto.visibilidadCampos(this.formInputPaso4, true, ['codigoDescuentoValido'], ['codigoDescuentoValido']);
          this.codigoDecuentoValido = x;
          this.formStepControlDatosContacto.formValidators.get('codigoDescuentoValido').setValue(peticion?.codigoDescuento);
          this.dialog.closeAll();
          this.notificacionDatosContacto.crearNotificacion(NotificacionEnum.Exito, 'Descuento válido', 'Código de descuento validado correctamente', false, IconEnum.Exito, '', true);
        },
        e => {
          this.formularioCodigoDescuento.formValueReset = true;
          this.notificacionCodigoDescuento.eliminarNotificaciones();
          this.notificacionCodigoDescuento.crearNotificacion(NotificacionEnum.Error, 'Error', 'El código de descuento no existe', true, IconEnum.Error);
        }
      );
  }

  // querys
  existeFechaTurnoSeleccionada() {
    return (this.reservaService.entidad$.value?.idTipoTurno !== '');
  }

  establecerHorasDisponiblesTipoTurno(idTipoTurno, turno) {
    console.log('Turno ', turno);
    let horasDisponiblePaquete = turno?.horasDisponiblePaquete.map(item => {
      console.log(item);
      return { id: item.hora, nombre: item.hora }
    }
    );
    this.auxiliarService.busquedaPropiedad(this.formInputPaso2, 'formControlName', 'horaInicio').datos = horasDisponiblePaquete;
  }

  actualizarReservaStore(datos) {
    return this.reservaService.actualizarReservaStorage(datos);
  }
  grabarReserva(datos) {
    if ( this.codigoDecuentoValido ) {
      datos.codigoDescuento = this.codigoDecuentoValido?.nombre;
    }
    this.reservaService.grabando = true;
    this.permitirProcesoPago = false;
    let datosActualizados = this.actualizarReservaStore(datos);
    // console.log("[GRABAMOS RESERVA ]", datosActualizados);
    if (datosActualizados?.codigo) {
      // console.log("[GRABAMOS RESERVA PATCH]", datosActualizados.codigo);
      // Actualizacion
      this.reservaService.update(datosActualizados.codigo, datosActualizados).subscribe(
        x => { this.actualizarReservaStore(x); this.establecerEstadoReservaPendiente(x); },
        e => {
          this.reservaService.grabando = false;
          this.notificacionDatosContacto.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Se ha producido un error al intentar consultar disponibilidad ' + e.data, true, IconEnum.Error);
          this.onAtras();
        }
      );
    } else {
      // Creacion
      this.reservaService.create(datosActualizados).subscribe(
        x => { this.actualizarReservaStore(x); this.establecerEstadoReservaPendiente(x); },
        e => {
          this.reservaService.grabando = false;
          this.notificacionDatosContacto.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Se ha producido un error al intentar consultar disponibilidad ' + e.data, true, IconEnum.Error);
          this.onAtras();
        }
      );
    }
  }
  establecerEstadoReservaPendiente(x) {
    // forzamos login
    this.authSerive.loginFrontAnonimo(x.codigoAcceso).subscribe(datos => {
      this.reservaService.establecerEstadoReservaPendiente(x.codigo).subscribe(
        x => {
          this.reservaService.actualizarReservaStorage({ ...x });
          this.reservaService.gestionarExtrasOpcionales();
          this.permitirProcesoPago = true;
          this.stepControlDatosContacto = true;
          this.reservaService.grabando = false;
          setTimeout(() => {
            this.siguiente();
          })
        },
        e => {
          this.reservaService.grabando = false;
          this.permitirProcesoPago = false;
        }
      );
    })
  }
  private obtenerParametrosConsultaConfiguracion(diaVista, margenDiasPrevios = 6, margenDiasPosteriores = 0) {
    let margenDias = 6;
    let formatFechaApi = 'dd/MM/yyyy';
    let primerDiaMes = this.auxiliarService.primerDiaMes(diaVista);
    let filtros = {
      fechaDesde: format(subDays(<Date>primerDiaMes, margenDiasPrevios), formatFechaApi),
      fechaHasta: format(addDays(<Date>this.auxiliarService.ultimoDiaMes(<Date>primerDiaMes), margenDiasPosteriores), formatFechaApi),
      idPaquete: this.calendarioOcioService.filtrosConsultaDisponibilidad$.value.idPaquete,
      idExtras: this.calendarioOcioService.filtrosConsultaDisponibilidad$.value?.idExtras,
    };
    return filtros;
  }


}

